import { FormGroup } from "@angular/forms";
import { disabledIntegration } from "./nexsys-form-config.model";
import { ValidationContext } from "@cv-invision/cv.invision-views.ux";
import { IntegrationConfig } from "./product.model";

export const VALUTRUST_FORM_CONFIG = {
	valutrust: {
		enabled:{
			path: 'valutrust.enabled',
			DataType: 'Boolean',
			DisplayText: `Valutrust`,
			Name: 'enabled',
			customClass: 'product-form-switch',
			UIEvents: {
				onChange: ($event: any, model: any, formGroup: FormGroup, extraData: any) => {
					disabledIntegration(formGroup);
					formGroup.get('valutrust')?.setValue(new IntegrationConfig());
					formGroup.get('valutrust.enabled')?.setValue($event.checked);
					formGroup.get('valutrust').updateValueAndValidity();
				},
			},
		},
		isDefaultProduct:{
			path: 'valutrust.isDefaultProduct',
			DataType: 'Boolean',
			DisplayText: `Default Product Configuration`,
			Name: 'isDefaultProduct',
			customClass: 'product-form-switch ms-5',
			required:false,
			UIEvents: {
				onChange: ($event: any, model: any, formGroup: FormGroup, extraData: any) => {

					formGroup.get('valutrust.productId')?.setValue(null);
					formGroup.get('valutrust.productName')?.setValue(null);

					if ($event.checked) {
						formGroup.get('isOrganizationLevel')?.setValue(false);
						formGroup.get('valutrust.productId')?.setValue('unknown');
						formGroup.get('valutrust.productName')?.setValue(null);
					}
					formGroup.get('valutrust').updateValueAndValidity();
				},
			},
		},
		productId:{
			DataType: 'Selector',
			path: 'valutrust.productId',
			UIControl: 'Dropdown',
			DisplayText: 'Product Name',
			label: 'Product Name',
			Name: 'productId',
			customClass: 'product-form-dropdown',
			options: [],
			UIOptions: {
				ShowClearButton: true,
				showLabel: true,
			},
			isRequired: function(control, jsonModelService: ValidationContext) {
				return jsonModelService.IsEmpty() && (jsonModelService.FindValue('isDefaultProduct') === false ) && jsonModelService.FindValue('enabled');
			},
			Visible: function(control, jsonModelService: ValidationContext) {
				const optionSelected = jsonModelService.FindValue('isDefaultProduct');
				return (optionSelected === false) || false;

			},
			UIEvents: {
				onChange: ($event: any, model: any, formGroup: any, formConfigModel: any) => {
					const value = $event.value;
					if (value !== '' && value !== null && value !== undefined) {
						const indexOption = formConfigModel.options.findIndex(element => element.value === value);
						const option = formConfigModel.options[ indexOption ];
						formGroup.get('integration.productName')?.setValue(option?.label);
					} else {
						formGroup.get('integration.productId')?.setValue(null);
						formGroup.get('integration.productName')?.setValue(null);
					}
				},
			},
		},
		productName:{
			DataType: 'String',
			path: 'valutrust.productName',
			DisplayText: 'Product Name',
			label: 'Product Name',
			Name: 'productName',
			required: false,
			hidden: true,
		},
		isFhaProduct:{
			path: 'valutrust.isFhaProduct',
			DataType: 'Boolean',
			DisplayText: `Is a FHA Product`,
			Name: 'isFhaProduct',
			customClass: 'product-form-switch ms-5',
			required: false,
			Visible: function(control, jsonModelService: ValidationContext) {
				const optionSelected = jsonModelService.FindValue('isDefaultProduct');
				return (optionSelected === false) || false;

			}
		},
		isOrderIncomeStatement:{
			path: 'valutrust.isOrderIncomeStatement',
			DataType: 'Boolean',
			DisplayText: `Is Order Income Statement`,
			Name: 'isOrderIncomeStatement',
			customClass: 'product-form-switch ms-3',
			required: false,
			Visible: function(control, jsonModelService: ValidationContext) {
				const optionSelected = jsonModelService.FindValue('isDefaultProduct');
				return (optionSelected === false) || false;

			}
		},
		isOrderRentSchedule:{
			path: 'valutrust.isOrderRentSchedule',
			DataType: 'Boolean',
			DisplayText: `Is Order Rent Schedule`,
			Name: 'isOrderRentSchedule',
			customClass: 'product-form-switch  ms-3',
			required: false,
			Visible: function(control, jsonModelService: ValidationContext) {
				const optionSelected = jsonModelService.FindValue('isDefaultProduct');
				return (optionSelected === false) || false;

			}
		},
		defaultFhaNumber:{
			path: 'valutrust.defaultFhaNumber',
			DataType: 'String',
			DisplayText: `Default FHA Number`,
			Name: 'defaultFhaNumber',
			customClass: '',
			required: false,
			Visible: function(control, jsonModelService: ValidationContext) {
				const optionSelected = jsonModelService.FindValue('isFhaProduct');
				return optionSelected || false;

			}
		}
	}
}
